import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/app.constants';
import { MerchantService } from '../../../services/index';
import { Merchant } from '../../../models/index';
import { SingleSelectComponent } from '../../../shared/components/single-select/single-select.component';

@Component({
  selector: 'select-merchant-dialog',
  templateUrl: './select-merchant-dialog.component.html',
  styleUrls: ['./select-merchant-dialog.component.css'],
})
export class SelectMerchantDialogComponent implements OnInit, AfterViewInit {
  form!: FormGroup;
  merchantFormControl!: FormControl;

  loading = false;
  error = false;
  merchants: Merchant[] = [];

  @ViewChild(SingleSelectComponent)
  singleSelectComponent!: SingleSelectComponent;

  constructor(
    public matDialogRef: MatDialogRef<SelectMerchantDialogComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private merchantService: MerchantService,
    private constants: Constants
  ) {}

  ngOnInit(): void {
    this.merchantFormControl = new FormControl({ value: '', disabled: false }, [
      Validators.required,
    ]);

    this.form = this.fb.group({
      merchant: this.merchantFormControl,
    });

    this.getMerchants();
  }

  getMerchants(): void {
    this.loading = true;

    this.merchantService
      .getMerchants(1000, 0)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.merchants = res.docs;
            this.merchants?.sort((a, b) => a.name!.localeCompare(b.name!));
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.loading = false));
  }

  ngAfterViewInit() {
    // Auto-focus the search input when the dialog opens
    setTimeout(() => {
      if (this.singleSelectComponent && this.singleSelectComponent.matSelect) {
        // Use the proper MatSelect API to open the dropdown
        this.singleSelectComponent.matSelect.open();

        // After the dropdown opens, focus the search input
        setTimeout(() => {
          const searchInput = document.querySelector(
            '.search-input'
          ) as HTMLInputElement;
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      }
    }, 100);
  }

  primaryTapped() {
    if (this.form?.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.matDialogRef.close(this.merchantFormControl.value);
  }
}
